module.exports = __webpack_public_path__ + "img/fragile-package.259ccfdf.svg";